import { ShieldCheck, Lock, ClipboardList, RefreshCw } from "lucide-react";

const PILLARS = [
  { Icon: ShieldCheck, title: "Trust", body: "One accountable partner across every device category and every service partner in the field." },
  { Icon: Lock, title: "Security", body: "Data handling and device access controls built into every step of the lifecycle, not bolted on after." },
  { Icon: ClipboardList, title: "Advisory", body: "Guidance on the right devices, the right partners, and the right process for your operation." },
  { Icon: RefreshCw, title: "Device Lifecycle", body: "Procurement through disposal, managed as one continuous process instead of disconnected vendors." },
];

const PillarCards = () => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
    {PILLARS.map(({ Icon, title, body }) => (
      <div key={title} className="dw-card text-center">
        <Icon className="mx-auto" size={32} strokeWidth={1.5} style={{ color: "var(--dw-accent)" }} />
        <h3 className="pt-3 text-base">{title}</h3>
        <p className="dw-mini pt-1 text-sm">{body}</p>
      </div>
    ))}
  </div>
);

export default PillarCards;
